export const ITEMS_PER_PAGE = 18
export const ITEMS_PER_SECTION = 18
export const DEFAULT_SELLER_MINIMUM_VALUES = 'tatauymontevideo'
export const PDP_SHIPPING_OPTIONS_TEXTS = {
  shippingLocalStorageKey: 'Location',
  shippingTypeDelivery: 'delivery',
  shippingTypePickup: 'pickup-in-point',
  shippingTypeAgree: 'acordar',
  shippingToAgreeText: 'A acordar',
  shippingFree: 'Gratis',
  shippingOptionsTitle: 'Opciones de envío y retiro:',
  shipTo: 'Enviar a',
  shippingChange: 'Cambiar',
  shippingDeliverySubtitle: 'Envio',
  shippingPickupSubtitle: 'Retiro',
  shippingMoreOptions: 'Ver más opciones de envio +',
  shippingModalTitle: 'Todas las opciones de envío y retiro',
  shippingModalRegionalizedSubtitle:
    'Calculamos los costos y tiempos para esta ubitación:',
}
export const PDP_SHIPPING_ESTIMATE = {
  '1bd': '24hs',
  '2bd': '24 a 48hs',
  '3bd': '24 a 72hs',
  '4bd': '24 a 96hs',
  '5bd': '24 a 120hs',
  '': '',
}
export const DEFAULT_SELLER_NUMBER = '1'
export const PRICE_TYPES = {
  listPrice: 'listPrice',
  sellingPrice: 'sellingPrice',
}

export const BRAINDW_EMPTY_OBJ = {
  filterSectionId: [],
  history: {
    productViewed: [],
    productAdded: [],
    searchedTerm: [],
    categoryViewed: [],
    collectionViewed: [],
  },
  current: {
    product: null,
    category: null,
    collection: null,
    searchTerm: '',
    cartOpen: [],
    cartClose: [],
  },
  session: {
    name: '',
    email: '',
    branchOffice: '',
    sellerId: '',
    guid: '',
    country: '',
    state: '',
    city: '',
    ip: '',
  },
  enable: 0,
}

export const BRAINDW_PRODUCTS_GETTER_URL =
  'https://s2.braindw.com/rule/tatauy_produccion_s4teh'
